import React from 'react';
import { useMediaQueryContext } from '@fourthwall/components';
import { routing } from '@utils/routing';
import { getBonus } from '../../utils';
import { Incentive } from '../Incentive';
export const PromotionIncentive = ({ incentive }) => {
    const { tablet } = useMediaQueryContext();
    const getIncentivePromotionName = (incentive) => {
        switch (incentive.promotionType) {
            case 'FreeShipping':
                return {
                    icon: '🚚',
                    label: 'Offer free shipping',
                };
            default:
                return {
                    icon: '🚚',
                    label: 'Offer promotion',
                };
        }
    };
    return (React.createElement(Incentive, { type: incentive.type, icon: getIncentivePromotionName(incentive).icon, label: getIncentivePromotionName(incentive).label, isCompleted: incentive.isCompleted, bonus: getBonus(incentive.bonus), button: {
            label: tablet ? 'Set up free shipping' : 'Set up',
            to: `${routing.promotions.promotionCodes.create.self}?mode=free-shipping`,
        } }));
};
